import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { useSiteConfig } from '../hooks/useSiteConfig';
import { openWhatsApp } from '../utils/whatsapp';

export default function FloatingWhatsApp() {
  const siteConfig = useSiteConfig();
  const { contact } = siteConfig;

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1, duration: 0.4 }}
      onClick={() => openWhatsApp(contact.whatsapp, contact.defaultMessage)}
      aria-label="WhatsApp 諮詢"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-neon-cyan to-neon-purple flex items-center justify-center shadow-neon-cyan animate-pulse-glow"
    >
      <MessageCircle size={26} className="text-deep-navy" />
    </motion.button>
  );
}
